import useAsyncEffect from "../../../../../hooks/useAsyncEffect";
import OrSpinner from "../../../../Utils/OrSpinner";
import { ListarMotivoParalisarController } from "../../../../../Controllers/AssistenciaTecnica/Atendimento/AcoesAtendimento/AcoesAtendimentoControllers";
import { IListarMotivoParalisarManutencao } from "../../../../../Interfaces/AssistenciaTecnica/Atendimento/ParalisarManutencao/ParalisarManutencaoInterfaces";
import { useState } from "react";
import { Collapse } from "react-bootstrap";
import ListagemMotivoParalisacao from "./ListagemMotivoParalisacao";
import CreateUpdateMotivoParalisacao from "./CreateUpdateMotivoParalisacao";

export default function MotivoParalisacao() {
    const [editting, setEditting] =
        useState<IListarMotivoParalisarManutencao>();

    const {
        value: lstMotivoParalisacao,
        execute: listarMotivosParalisacao,
        loading,
    } = useAsyncEffect(ListarMotivoParalisarController);

    function updateListMotivoParalisacao() {
        listarMotivosParalisacao();
        setEditting(undefined);
    }

    function Edit(toEdit: IListarMotivoParalisarManutencao) {
        if (
            editting?.ID_MOTIVO_PARALIZACAO_SLA ===
            toEdit.ID_MOTIVO_PARALIZACAO_SLA
        )
            setEditting(undefined);
        else if (!editting) {
            setEditting(toEdit);
        } else {
            setEditting(undefined);
            setTimeout(() => {
                setEditting(toEdit);
            }, 500);
        }
    }

    return (
        <>
            <div className="col-12 collapse mb-5" id="collapseForm">
                <CreateUpdateMotivoParalisacao
                    onSave={() => {
                        updateListMotivoParalisacao();
                    }}
                />
            </div>
            <div className="w-100">
                <OrSpinner loading={loading} spinner="capys">
                    {lstMotivoParalisacao ? (
                        <ListagemMotivoParalisacao
                            lstMotivoParalisacao={lstMotivoParalisacao}
                            setEdit={Edit}
                            updateListMotivoParalisacao={
                                updateListMotivoParalisacao
                            }
                        />
                    ) : (
                        <div className="text-center text-muted">
                            Erro ao carregar lista de motivo paralisação
                        </div>
                    )}
                </OrSpinner>
            </div>
            <Collapse in={!!editting} mountOnEnter unmountOnExit>
                <CreateUpdateMotivoParalisacao
                    motivoParalisacao={editting}
                    onSave={() => {
                        updateListMotivoParalisacao();
                    }}
                />
            </Collapse>
        </>
    );
}
